import React from 'react';
import { Table } from 'reactstrap';

import SuccessFailureProgressBar from 'components/FlexSuccessFailureProgressBar';
const thStyle = {
  whiteSpace: 'break-spaces',
  textAlign: 'center'
};

const formatTime = (tempo) => {
  if (!tempo) return '00:00:00';
  const hours = (tempo.hours !== undefined ? tempo.hours : 0)
    .toString()
    .padStart(2, '0');
  const minutes = (tempo.minutes !== undefined ? tempo.minutes : 0)
    .toString()
    .padStart(2, '0');
  const seconds = (tempo.seconds !== undefined ? tempo.seconds : 0)
    .toString()
    .padStart(2, '0');
  return `${hours}:${minutes}:${seconds}`;
};

/**
 * Component to render a table displaying pending dialer data.
 *
 * @param {Object} props - The component props.
 * @param {Array} props.data - The data to be displayed in the table.
 * @param {Object} props.data[].tentativa - The attempt number.
 * @param {Object} props.data[].sucesso - The number of successful attempts.
 * @param {Object} props.data[].insucesso - The number of unsuccessful attempts.
 * @param {Object} props.data[].pendente - The number of pending attempts.
 * @param {Object} props.data[].tempo_da_tentativa - The time taken for the attempt.
 * @param {Object} props.data[].count - The total count of attempts.
 *
 * @returns {JSX.Element} The rendered table component.
 */
const PendingDialerTable = ({ data }) => {
  return (
    <Table className="mb-5 overflow-y-visible" bordered={true} striped>
      <thead>
        <tr>
          <th style={thStyle}>Tentativa</th>
          <th style={thStyle}>Sucesso</th>
          <th style={thStyle}>Insucesso</th>
          <th style={thStyle}>Pendente</th>
          <th style={thStyle}>Tempo da Tentativa</th>
          <th style={thStyle}>Status</th>
          <th style={thStyle}>Barra de progresso</th>
        </tr>
      </thead>
      <tbody>
        {data &&
          data.map((row, i) => {
            const totalAttempts = Number(row.sucesso) + Number(row.insucesso);
            const percentage = (totalAttempts / Number(row.count)) * 100;
            let status = '';
            if (percentage === 100) {
              status = 'Finalizado';
            } else if (percentage === 0) {
              status = 'Nao iniciado';
            } else {
              status = 'Em progresso';
            }

            return (
              <tr key={i}>
                <td>{row.tentativa}&ordf;</td>
                <td>{row.sucesso}</td>
                <td>{row.insucesso}</td>
                <td>{row.pendente}</td>
                <td>
                  {status !== 'Nao iniciado'
                    ? formatTime(row.tempo_da_tentativa)
                    : '00:00:00'}
                </td>
                <td>{status}</td>
                <td>
                  <SuccessFailureProgressBar
                    insucesso={row.insucesso}
                    sucesso={row.sucesso}
                    count={row.count}
                  />
                </td>
              </tr>
            );
          })}
      </tbody>
    </Table>
  );
};

export default PendingDialerTable;
